import React, { useMemo, useState } from 'react';
import { Helmet } from 'react-helmet-async';
import { useIntl } from 'react-intl';

import Icon from '@/components/Base/Icon';
import { usePageProps } from '@/hooks';
import { getCurrentPageType } from '@/utils';

import { StaticContentTitle } from '../StaticContent.styles';

import {
  QuestionItem,
  StiledSubtitle,
  StyledStaticContentSection,
  StyledText,
} from './FAQ.styles';

const questions = Array.from({ length: 8 }).map((_, index) => index);

export function FAQ() {
  const { formatMessage } = useIntl();
  const { params } = usePageProps();

  // Визначаємо тип сторінки залежно від params
  const pageType = getCurrentPageType({ params });
  const initialFAQState = useMemo(
    () =>
      questions.reduce(
        (acc, element, index) => ({
          ...acc,
          [index]: true,
        }),
        {}
      ),
    questions
  );
  const [FAQState, setFAQState] = useState(initialFAQState);

  const handleFAQClick = (id) => {
    setFAQState({
      ...FAQState,
      [id]: !FAQState[id],
    });
  };
  const a = (chunks) => (
    <a target="_blank" href="https://policy.mtsbu.ua/" rel="noreferrer">
      {chunks}
    </a>
  );
  const questionData = questions.map((item) => ({
    '@type': 'Question',
    name: `${formatMessage({ id: `staticContent.faq.${pageType}${params.category ? `.${params.category}` : ''}.question.${item}` })}`,
    acceptedAnswer: {
      '@type': 'Answer',
      text: `${formatMessage({ id: `staticContent.faq.${pageType}${params.category ? `.${params.category}` : ''}.answer.${item}` }, { a })}`,
    },
  }));

  const faqSchema = [
    {
      type: 'application/ld+json',
      innerHTML: JSON.stringify({
        '@context': 'http://schema.org',
        '@type': 'FAQPage',
        mainEntity: questionData,
      }),
    },
  ];

  return (
    <>
      <Helmet script={faqSchema} />

      <StyledStaticContentSection id="faq" className="sections">
        <StaticContentTitle $marginBottom="8">
          {formatMessage({
            id: 'staticContent.anchorLinks.map.title.faq',
          })}
        </StaticContentTitle>

        {questions?.map((item, index) => (
          <QuestionItem key={item} onClick={() => handleFAQClick(index)}>
            <StiledSubtitle as="button">
              {formatMessage({
                id: `staticContent.faq.${pageType}${params.category ? `.${params.category}` : ''}.question.${item}`,
              })}
              <Icon
                name="arrowRight"
                style={{
                  transform: FAQState[index]
                    ? 'rotate(270deg)'
                    : 'rotate(90deg)',
                }}
              />
            </StiledSubtitle>

            <StyledText $show={FAQState[index]}>
              {formatMessage(
                {
                  id: `staticContent.faq.${pageType}${params.category ? `.${params.category}` : ''}.answer.${item}`,
                },
                { a }
              )}
            </StyledText>
          </QuestionItem>
        ))}
      </StyledStaticContentSection>
    </>
  );
}

export default FAQ;
